import { styled } from 'styled-components';

export const Strikethrough = styled.span`
	text-decoration: line-through;
	color: ${({ theme }) => theme.colors.textError};
`;

export const Subtle = styled.span`
	color: ${({ theme }) => theme.colors.textSubtle};
`;
